var Component = require('./Component');

module.exports = Component;
